export { default } from './usePreviousProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/usePreviousProps/index.js
// module id = 842
// module chunks = 25